//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider, Tag, Select, Option, Col, Button, Upload, Checkbox} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
import CySelect from '../../../components/select/CySelect'
import CyAutocomplete from '../../../components/autocompletes/CyAutocomplete'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Col)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Checkbox)
export default {
  name: 'StockInConfirm',
  components: {
    CyMobileLayout,
    CySelect,
    CyAutocomplete
  },
  data () {
    return {
      packageList: [],
      positionList: [],
      materialList: [],
      jgFlag: true,
      ctnFlag: false,
      weightFlag: false,
      pictureFlag: false,
      planId: this.$route.query.planId,
      planDateId: this.$route.query.planDateId,
      baseInfo: {},
      cargoList: [],
      ctnList: [],
      stockIn: {container_no: '', truck_no: '', truck_driver: '', truck_mobile: ''}, // 入库信息
      stockInCargoList: [{goods_name: '', goods_package_name: '', stockin_number: '', stockin_weight: '', stockin_volume: '', stockin_db_weight: '', storage_position: '', goods_flag: 1, stock_flag: 1}],
      finishedCargoList: [{goods_name: '', goods_package_name: '', stockin_number: '', stockin_weight: '', stockin_volume: '', stockin_db_weight: '', storage_position: '', goods_flag: 2, stock_flag: 1}],
      rejectedCargoList: [{goods_name: '', goods_package_name: '', stockin_number: '', stockin_weight: '', stockin_volume: '', stockin_db_weight: '', storage_position: '', goods_flag: 3, stock_flag: 1}],
      stockInMaterialList: [{material_name: '', amount: ''}],
      fileList: []
    }
  },
  mounted () {
    this.init()
  },
  created () {
    // 判断计划是否被仓库确认，如果未确认，跳转至确认页面
  },
  methods: {
    init: function () {
      let that = this
      if (that.$Utils.IsEmpty(that.planDateId)) {
        that.getPlanDateId(that.planId)
      }
      let url = '/wms/stockin/confirm/getStockInPlanInfo'
      console.log(that.planId)
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          that.baseInfo = res.data.baseInfo
          that.ctnList = res.data.ctnList
          that.ctnFlag = that.baseInfo.stockin_ctn_flag === 1
          that.jgFlag = that.baseInfo.cargo_process_flag === 1
          that.weightFlag = that.baseInfo.cargo_weight_flag === 1
          that.pictureFlag = that.baseInfo.cargo_picture_flag === 1
          that.stockIn.stockin_plan_id = that.baseInfo.stockin_plan_id
          that.cargoList = res.data.cargoList
          // 计算获取剩余入库计划量
          that.stockInCargoList = []
          for (var i = 0; i < that.cargoList.length; i++) {
            that.cargoList[i].stockin_number = that.cargoList[i].goods_number - that.cargoList[i].goods_number_in
            that.cargoList[i].stockin_weight = that.cargoList[i].goods_weight - that.cargoList[i].goods_weight_in
            that.cargoList[i].stockin_volume = that.cargoList[i].goods_volume - that.cargoList[i].goods_volume_in
            var cgitem = {}
            that.$Utils.copyJsonObject(cgitem, that.cargoList[i])
            that.stockInCargoList.push(cgitem)
          }
        }
      })
      // 根据仓库companyid获取库位列表
      that.getPositionList(that.baseInfo.storage_companyid)
      that.getMaterialList()
    },
    ctnSelectChange: function (truck) {
      let that = this
      if (that.$Utils.IsEmpty(truck)) {
        return
      }
      this.stockIn.truck_no = truck.truck_no
      this.stockIn.truck_driver = truck.truck_driver
      this.stockIn.truck_mobile = truck.truck_mobile
      if (that.stockInCargoList != null && that.stockInCargoList.length > 0) {
        if (!that.$Utils.IsEmpty(truck.ctn_number)) {
          that.stockInCargoList[0].stockin_number = truck.ctn_number
        }
        if (!that.$Utils.IsEmpty(truck.ctn_weight)) {
          that.stockInCargoList[0].stockin_weight = truck.ctn_weight
        }
        if (!that.$Utils.IsEmpty(truck.ctn_volume)) {
          that.stockInCargoList[0].stockin_volume = truck.ctn_volume
        }
      }
    },
    getPositionList: function () {
      let that = this
      let url = '/inter/storage/getPositionListForSelect'
      that.$axiosWeb.post(url).then(function (res) {
        if (res.meta.success) {
          that.positionList = res.data
        }
      })
    },

    getMaterialList: function () {
      let that = this
      let url = '/inter/reinforcematerial/getMaterialListForSelect'
      that.$axiosWeb.post(url).then(function (res) {
        if (res.meta.success) {
          that.materialList = res.data
        }
      })
    },

    getPlanDateId: function (planId) {
      let that = this
      let url = '/wms/stockin/confirm/getPlanDateId'
      that.$axiosWeb.post(url, null, {params: {planId: planId}}).then(function (res) {
        if (res.meta.success) {
          that.planDateId = res.data.id
        }
      })
    },

    addCargo: function (type) {
      let that = this
      if (type === '1') {
        that.stockInCargoList.push({goods_name: '', goods_package_name: '', stockin_number: '', stockin_weight: '', stockin_volume: '', stockin_db_weight: '', storage_position: '', goods_flag: 1, stock_flag: 1})
      } else if (type === '2') {
        that.finishedCargoList.push({goods_name: '', goods_package_name: '', stockin_number: '', stockin_weight: '', stockin_volume: '', stockin_db_weight: '', storage_position: '', goods_flag: 2, stock_flag: 1})
      } else if (type === '3') {
        that.rejectedCargoList.push({goods_name: '', goods_package_name: '', stockin_number: '', stockin_weight: '', stockin_volume: '', stockin_db_weight: '', storage_position: '', goods_flag: 3, stock_flag: 1})
      }
    },

    deleteCargo: function (cargo, idx, type) {
      if (type === '1') {
        this.stockInCargoList.splice(idx, 1)
      } else if (type === '2') {
        this.finishedCargoList.splice(idx, 1)
      } else if (type === '3') {
        this.rejectedCargoList.splice(idx, 1)
      }
    },

    cargoSelected: function (item, cargo, idx) {
      console.log(item)
      cargo.stockin_number = item.stockin_number
      cargo.stockin_weight = item.stockin_weight
      cargo.stockin_volume = item.stockin_volume
    },

    addMaterial: function () {
      this.stockInMaterialList.push({material_name: '', amount: ''})
    },
    deleteMaterial: function (idx) {
      this.stockInMaterialList.splice(idx, 1)
    },

    submitConfirm: function () {
      let that = this
      let url = '/wms/stockin/detail/createStockInDetail'
      let stockinParam = {}
      if (that.$Utils.IsEmpty(that.stockIn.stockin_loading_team_id)) {
        that.$Msgbox.alert('请选择装卸队')
        return false
      }
      stockinParam.planDateId = that.planDateId
      stockinParam.stockinDetail = that.stockIn
      stockinParam.stockinDetail.stockin_date = that.$Utils.dateFormat(new Date(), 'yyyy-MM-dd')
      let goodsList = that.stockInCargoList
      if (that.jgFlag && that.finishedCargoList != null && that.finishedCargoList.length > 0) {
        goodsList.forEach(function (item) {
          item.stock_flag = 0
        })
        goodsList = goodsList.concat(that.finishedCargoList, that.rejectedCargoList)
      }

      stockinParam.goodsList = goodsList
      stockinParam.materialList = that.stockInMaterialList
      stockinParam.fileList = that.fileList
      that.$axiosWeb.post(url, stockinParam).then(function (res) {
        if (res.meta.success) {
          that.$Msgbox.alert('入库成功', '入库成功')
          location.href = '/wx/wms/stockInRecordDetail?planId=' + that.planId + '&detailId=' + res.data.stockin_detail_id + '&planDateId=' + that.planDateId
        } else {
          that.$Msgbox.alert(res.meta.message, '入库失败')
        }
      })
    },

    uploadSucces: function (res, file, fileList) {
      let that = this
      if (res.meta.success) {
        that.fileList.push({uid: file.uid, name: file.name, url: res.data.fileAbsoluteUrl})
      } else {
        that.$Msgbox.alert(res.meta.message, '错误提示')
      }

      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(this.fileList)
    },

    fileRemoveSucces: function (file, fileList) {
      let that = this
      let uid = file.uid
      let index = that.fileList.findIndex((item) => item.uid === uid)
      that.fileList.splice(index, 1)
      console.log(file)
      console.log(fileList)
      console.log(this.fileList)
    },
    goDetail: function () {
      let that = this
      location.href = '/wx/wms/stockInRecordDetail?planId=' + that.planId + '&planDateId=' + that.planDateId
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockin/StockInConfirm.vue